import store from '@/store';
import { computed, Ref } from 'vue';
import { IUseOverlay } from '@/interfaces/IUseOverlay';

const useOverlay = (): IUseOverlay => {
  const getOverlayOpen: Ref<boolean> = computed((): boolean => store.state.modes.showOverlay);
  const showOverlay = (): void => { store.commit('showOverlay'); };
  const hideOverlay = (): void => { store.commit('hideOverlay'); };

  return {
    getOverlayOpen,
    showOverlay,
    hideOverlay,
  };
};

export default useOverlay;
